'use strict';

var _ = require('lodash');
var ReviewInputDataChartLegendController = function ReviewInputDataChartLegendController($scope, seasonalityConstants, configurationService) {
  $scope.displayMode = seasonalityConstants.DISPLAY_BY_WEEK_MODE;
  $scope.classGroupList = [];
  $scope.sposList = [];
  $scope.showMarket = false;
  $scope.showClassGroup = false;
  $scope.showSPOS = false;
  function getFilter() {
    return {
      allWeek: isAllWeek(),
      dowSelection: getDowSelection(),
      displayMode: $scope.displayMode,
      selectedMarket: $scope.selectedMarket,
      classGroup: $scope.classGroup,
      spos: $scope.spos
    };
  }
  function selectAllDow(select) {
    var size = $scope.legend.length - 1;
    for (var i = 1; i <= size; i++) {
      $scope.legend[i].selected = select;
    }
  }
  function disableDowSelection() {
    var selectedIndex;
    var selectedCount = 0;
    var size = $scope.legend.length - 1;
    for (var i = 0; i <= size; i++) {
      $scope.legend[i].selectable = true;
      if ($scope.legend[i].selected) {
        selectedIndex = i;
        selectedCount++;
      }
    }
    if (selectedCount === 1 && selectedIndex !== 0) {
      $scope.legend[selectedIndex].selectable = false;
    }
  }
  function getDowSelection() {
    var result = [];
    var size = $scope.legend.length - 1;
    for (var i = 1; i <= size; i++) {
      if ($scope.legend[i].selected) {
        result.push($scope.legend[i].id);
      }
    }
    return result;
  }
  function isAllWeek() {
    return $scope.legend[0].selected;
  }
  $scope.$on('chart-legend:legend-item-toggle', function (evt, data) {
    if (data.id === 'all') {
      var selection = getDowSelection();
      if (!data.selected && selection.length === 0) {
        selectAllDow(true);
      }
    }
    disableDowSelection();
    $scope.$emit('chart-legend:legend-filter-changed', getFilter());
  });
  $scope.$watch('markets', function (newVal) {
    if (newVal) {
      $scope.selectedMarket = _.includes(newVal, $scope.selectedMarket) ? $scope.selectedMarket : newVal[0];
    } else {
      $scope.selectedMarket = null;
    }
  });
  $scope.$watch('level', function (newVal) {
    if (newVal) {
      $scope.showMarket = newVal.indexOf('Mkt') !== -1;
      $scope.showClassGroup = newVal.indexOf('Prod Grp') !== -1;
      $scope.showSPOS = newVal.indexOf('POS') !== -1;
      populateDropDowns();
    } else {
      $scope.$emit('chart-legend:legend-filter-changed', getFilter());
    }
  });
  $scope.$watch('selectedMarket', function (newVal) {
    if (newVal) {
      populateDropDowns();
    }
    $scope.$emit('chart-legend:legend-filter-changed', getFilter());
  });
  $scope.$watchGroup(['displayMode', 'classGroup', 'spos'], function () {
    $scope.$emit('chart-legend:legend-filter-changed', getFilter());
  });
  function getNewValue(shown, allValues, value) {
    if (shown) {
      return _.includes(allValues, value) ? value : allValues[0];
    }
    return undefined;
  }
  function populateDropDowns() {
    $scope.classGroupList = configurationService.getClassGroupsByMarket($scope.selectedMarket);
    $scope.sposList = filterPosesByMarket(configurationService.getPoses());
    $scope.classGroup = getNewValue($scope.showClassGroup, $scope.classGroupList, $scope.classGroup);
    $scope.spos = getNewValue($scope.showSPOS, $scope.sposList, $scope.spos);
  }
  function filterPosesByMarket(poses) {
    return _.chain(poses).filter(function (pos) {
      return pos.origin + '-' + pos.destination === $scope.selectedMarket;
    }).map('spos').uniq().value();
  }
};
ReviewInputDataChartLegendController.$inject = ['$scope', 'SeasonalityConstants', 'ConfigurationService'];
module.exports = ReviewInputDataChartLegendController;